module.exports = __webpack_public_path__ + "img/ic_right.fd6a0fb2.svg";